import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../api/axios_interceptor";
import { get_jwt_token } from "../../api/helper_funtions";

import { ERROR, IDLE, LOADING, SUCCESS } from "../constants";

//blank string will be the ip provided by customer, else we use current url
let currentUrl;
let epmUrl;
let oauthUrl;
let auditsUrl;
let mediaUrl;
let dbProxyUrl;

const basePath = '/pam';

export function constructUrl(path) {
  return `${window.location.origin}${basePath}${path}`;
}

currentUrl = constructUrl('/apps');
epmUrl = constructUrl('/epm');
oauthUrl = constructUrl('/openid');
auditsUrl = constructUrl('');
mediaUrl = constructUrl('');
dbProxyUrl = constructUrl('/db-proxy');

export const getSessionInfo = createAsyncThunk(
  "audits/getSessionInfo",
  async (arg, thunkAPI) => {
    try {
      const token = get_jwt_token();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      let url = `/audits/session-recording/`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getResourceSessionInfo = createAsyncThunk(
  "audits/getResourceSessionInfo",
  async (arg, thunkAPI) => {
    try {
      const token = get_jwt_token();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      let url = `/audits/resource-session-recording/`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getLiveStreamInfo = createAsyncThunk(
  "audits/getLiveStreamInfo",
  async (arg, thunkAPI) => {
    try {
      const token = get_jwt_token();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      let url = `/customer/live-stream-setting/`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getResourceLiveStreamInfo = createAsyncThunk(
  "audits/getResourceLiveStreamInfo",
  async (arg, thunkAPI) => {
    try {
      const token = get_jwt_token();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      let url = `/customer/resource-live-stream-setting/`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getProxyInfo = createAsyncThunk(
  "audits/getProxyInfo",
  async (arg, thunkAPI) => {
    try {
      const token = get_jwt_token();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      let url = `/customer/proxy-setting/`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getDiscoveryFeatureAccess = createAsyncThunk(
  "customerLicense/getDiscoveryFeatureAccess",
  async (arg, thunkAPI) => {
    try {
      const token = get_jwt_token();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      let url = `/customer-license/discovery-feature-access-check/`;
      const response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

const customerSlice = createSlice({
  name: "customer",
  initialState: {
    status: IDLE,
    serverUrl: currentUrl,
    epmServerUrl: epmUrl,
    oauthUrl: oauthUrl,
    auditsUrl: auditsUrl,
    mediaUrl: mediaUrl,
    recordSession: "",
    resourceRecordSession: "",
    liveStream: "",
    resourceLiveStream: "",
    enableProxy: "false",
    dbProxyUrl: dbProxyUrl,
    isOnPremise: null,
    allowDiscoveryFeature: null,
  },
  reducers: {
    clearErrors: (state) => {
      state.status = IDLE;
      state.error = null;
    },
    resetSuccess: (state) => {
      state.status = IDLE;
      state.successMessage = null;
    },
    setRecordSession: (state, action) => {
      state.recordSession = action.payload.record_session;
    },
    setResourceRecordSession: (state, action) => {
      state.resourceRecordSession = action.payload.resource_session_record;
    },
    setLiveStream: (state, action) => {
      state.liveStream = action.payload.live_stream;
    },
    setResourceLiveStream: (state, action) => {
      state.resourceLiveStream = action.payload.resource_live_stream;
    },
    setEnableProxy: (state, action) => {
      state.enableProxy = action.payload.enable_proxy;
    },
    setIsOnPremise: (state, action) => {
      state.isOnPremise = action.payload;
    },
    setAllowDiscoveryFeature: (state, action) => {
      state.allowDiscoveryFeature = action.payload.allow_discovery_feature;
    },
  },
  extraReducers: {
    [getSessionInfo.pending]: (state) => {
      state.status = LOADING;
    },
    [getSessionInfo.fulfilled]: (state, action) => {
      state.status = SUCCESS;
      state.recordSession = action.payload.value;
    },
    [getSessionInfo.rejected]: (state, action) => {
      state.error = action.payload.errors;
      state.status = ERROR;
    },

    [getResourceSessionInfo.pending]: (state) => {
      state.status = LOADING;
    },
    [getResourceSessionInfo.fulfilled]: (state, action) => {
      state.status = SUCCESS;
      state.resourceRecordSession = action.payload.value;
    },
    [getResourceSessionInfo.rejected]: (state, action) => {
      state.error = action.payload.errors;
      state.status = ERROR;
    },

    [getLiveStreamInfo.pending]: (state) => {
      state.status = LOADING;
    },
    [getLiveStreamInfo.fulfilled]: (state, action) => {
      state.status = SUCCESS;
      state.liveStream = action.payload.value;
    },
    [getLiveStreamInfo.rejected]: (state, action) => {
      state.error = action.payload.errors;
      state.status = ERROR;
    },
    [getResourceLiveStreamInfo.pending]: (state) => {
      state.status = LOADING;
    },
    [getResourceLiveStreamInfo.fulfilled]: (state, action) => {
      state.status = SUCCESS;
      state.resourceLiveStream = action.payload.value;
    },
    [getResourceLiveStreamInfo.rejected]: (state, action) => {
      state.error = action.payload.errors;
      state.resourceLiveStream = ERROR;
    },
    [getProxyInfo.pending]: (state) => {
      state.status = LOADING;
    },
    [getProxyInfo.fulfilled]: (state, action) => {
      state.status = SUCCESS;
      state.enableProxy = action.payload.value;
    },
    [getProxyInfo.rejected]: (state, action) => {
      state.error = action.payload.errors;
      state.status = ERROR;
    },
    [getDiscoveryFeatureAccess.pending]: (state) => {
      state.status = LOADING;
    },
    [getDiscoveryFeatureAccess.fulfilled]: (state, action) => {
      state.status = SUCCESS;
      state.allowDiscoveryFeature = action.payload.allow_discovery_feature;
    },
    [getDiscoveryFeatureAccess.rejected]: (state, action) => {
      state.error = action.payload.errors;
      state.status = ERROR;
    },
  },
});

export const {
  clearErrors,
  resetSuccess,
  setRecordSession,
  setLiveStream,
  setResourceLiveStream,
  setResourceRecordSession,
  setEnableProxy,
  setIsOnPremise,
  setAllowDiscoveryFeature,
} = customerSlice.actions;
export default customerSlice.reducer;
